import Loader from '@/Helpers/Loader';

export const RequestLoaderInterceptor = conf => {
  Loader.loading();
  return conf;
};
